// extracted by mini-css-extract-plugin
export default {"item":"InfoItem_item__6lD6h","key":"InfoItem_key__jhNHD","value":"InfoItem_value__E-lde"};